import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_LOCATIONS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: LocationPageFilter
	) {
		getLocations(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
				coordinates
				accessHours
				directions
			}
			count
		}
	}
`;


const LocationSelector = (props) => {

	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_LOCATIONS}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select location"
			{...props}
		/>
	);
};

export default LocationSelector;
